import styles from './AppShare.module.scss';
import React, { useState } from 'react';
import { useAppContext } from '../../Services/AppContext';

interface IAppShare {}

export default function AppShare(props: IAppShare) {
	const { translation } = useAppContext();
	const [showQr, setShowQr] = useState(false);

	const handleClick = () => {
		setShowQr(prev => !prev);
	};

	return (
		<>
			<img
				className={styles.qr}
				src='/dist/patientV3/icons/qr-store.svg'
				alt='gr'
				height='36px'
				width='36px'
				onClick={handleClick}
			/>
			{showQr && (
				<div className={styles.wrapper}>
					<div className={styles.window}>
						<div className={styles.header}>
							<div className={styles.title}>
								{translation['layout.footer.downloadApp']}
							</div>
							<div className={styles.close} onClick={handleClick}>
								{translation['base.shared.close']}
							</div>
						</div>
						<div className={styles.body}>
							<img
								src='/dist/patientV3/icons/qr-store.svg'
								alt='gr'
								height='300px'
								width='300px'
							/>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
